module.exports = __webpack_public_path__ + "static/media/Battery-electrical-system-diagram.4f6fae5a.png";